<script setup lang="ts">
import { computed } from 'vue'
import ContactForm from '@/shared/components/ContactForm.vue'
import ReminderSignup from '@/shared/components/ReminderSignup.vue'
import { contactContext } from '../store'

const hasVerdict = computed(() => contactContext.value !== undefined)
</script>

<template>
    <section id="contact" class="site-section">
        <div class="site-content narrow">
            <div v-reveal class="card">
                <p v-if="hasVerdict" class="attached">
                    📎 Your wizard answers and verdict ride along with this request — the pros
                    quote your actual situation, not a cold call.
                </p>
                <ContactForm
                    heading="Get real quotes, not guesses"
                    subheading="Leave your details and a licensed local professional will reach out with actual numbers for your system. No obligation — comparing quotes is exactly what you should be doing."
                    :context="contactContext"
                    description-placeholder="System age, what it's doing, and any quote you already have…"
                    submit-label="Get My Quotes"
                />
            </div>

            <div v-reveal class="card block">
                <ReminderSignup />
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.narrow {
    max-width: 46rem;
}

.card {
    background: var(--site-surface);
    border: 2px solid var(--site-text);
    border-radius: var(--site-radius-md);
    box-shadow: var(--site-shadow-md);
    padding: var(--site-space-lg);
}

.attached {
    padding: var(--site-space-sm) var(--site-space-md);
    background: var(--site-accent-soft);
    border-radius: var(--site-radius-sm);
    font-size: 0.92rem;
    margin-bottom: var(--site-space-lg);
}

.block {
    margin-top: var(--site-space-xl);
}
</style>
